/**
 * Normalises what a visitor types as their website ("exempel.se",
 * "https://www.företag.se/") to a display host, or null if it isn't a plausible address.
 */
export function normalizeWebsite(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed || /\s/.test(trimmed)) return null;
  const withScheme = /^[a-z][a-z\d+.-]*:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  let url: URL;
  try {
    url = new URL(withScheme);
  } catch {
    return null;
  }
  if (url.protocol !== "http:" && url.protocol !== "https:") return null;
  // Validate the typed host (URL() converts IDNs like företag.se to punycode).
  const typedHost = withScheme.replace(/^[a-z][a-z\d+.-]*:\/\//i, "").split(/[/?#:]/)[0].toLowerCase();
  const labels = typedHost.split(".");
  if (labels.length < 2) return null;
  if (!labels.every((label) => /^[\p{L}\p{N}](?:[\p{L}\p{N}-]*[\p{L}\p{N}])?$/u.test(label))) return null;
  if (!/^\p{L}{2,}$/u.test(labels[labels.length - 1])) return null;
  const path = url.pathname === "/" ? "" : url.pathname.replace(/\/$/, "");
  return `${typedHost.replace(/^www\./, "")}${path}`;
}
